<template>
  <div>
    <div
      id="choose-your-experience"
      aria-hidden="true"
      class="modal"
      data-backdrop="exampleModalLabel"
      data-keyboard="false"
      tabindex="-1"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <section id="infoa" class="py-3">
              <a
                v-dataanchor
                class="close"
                data-bs-dismiss="modal"
                href="javascript:void(0)"
                tagAction="close"
                tagEvent="modal"
                tagSection="choose your experience"
                tagText="close cross"
                tagType="click"
                type="button"
                @click="remoteExpErr = null"
              >
                <img alt="times solid" src="../assets/icons/times-solid.svg" />
              </a>
              <div class="container text-white">
                <div class="row justify-content-center">
                  <h2 class="text-white title font-24 font-md-38">Choose your experience</h2>
                  <p class="text-white description">
                    Dreamscape Learn can be completed as a multi-sensory experience on the ASU Tempe
                    campus in the Dreamscape Studio pods. Alternatively, the experience can be
                    explored anytime, anywhere using your computer or PC-powered VR Headset.
                  </p>
                </div>
                <div :class="enableTwoD() ? 'row' : ''">
                  <a
                    v-dataanchor
                    class="col-12 col-lg-6 align-self-center"
                    href="javascript:void(0)"
                    tagAction="open"
                    tagEvent="modal"
                    tagSection="choose your experience"
                    tagText="pod experience"
                    tagType="click"
                  >
                    <img
                      alt="pod image"
                      class="pod-image"
                      data-bs-dismiss="modal"
                      data-target="#podSession"
                      data-toggle="modal"
                      src="../assets/images/pod-experience.png"
                      style="cursor: pointer"
                    />
                    <h3
                      class="text-center exp font-18 font-md-27"
                      data-bs-dismiss="modal"
                      data-target="#podSession"
                      data-toggle="modal"
                    >
                      Pod Experience
                    </h3>
                  </a>
                  <a
                    v-if="enableTwoD()"
                    v-dataanchor
                    class="col-12 col-lg-6 justify-content-center"
                    href="javascript:void(0)"
                    tagAction="click"
                    tagEvent="link"
                    tagSection="choose your experience"
                    tagText="anytime, anywhere"
                    tagType="internal link"
                  >
                    <img
                      alt="pod image"
                      class="pod-image"
                      src="../assets/images/anywhere-anytime.png"
                      style="cursor: pointer"
                      @click="remoteInit()"
                    />
                    <h3 class="text-center exp font-18 font-md-27" @click="remoteInit()">
                      Anytime, anywhere
                    </h3>
                  </a>
                </div>
                <p v-if="remoteExpErr && enableTwoD()" class="text-danger d-inline-block mt-3 mb-0">
                  {{ remoteExpErr }}
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';
import { API } from '@/utils/amplifyCompat';
import {
  dataLayerAnchorTag,
  dataLayerButtonTag,
  dataLayerSelectTag,
  dataLayerInputTag,
} from 'data-layer-test-oo-gtm';
import { useLegacyStore } from '@/composables/useLegacyGlobals';

export default defineComponent({
  name: 'ChooseYourExperienceModal',
  directives: {
    dataanchor: dataLayerAnchorTag,
    databutton: dataLayerButtonTag,
    'data-select': dataLayerSelectTag,
    'data-input': dataLayerInputTag,
  },
  setup() {
    const remoteExpErr = ref(null);
    const store = useLegacyStore();

    const enableTwoD = () => {
      const pods = store.state.scheduler_pods;
      if (pods && pods[0] && pods[0]['2d']) {
        const twoDtitle = pods[0]['2d'].find(
          (status) => status.title_id === store.state.selected_title_id
        );
        return twoDtitle !== undefined;
      }
      return false;
    };

    const remoteInit = async () => {
      const myInit = {
        body: {
          title_id: store.state.selected_title_id,
          site_id: store.state.selected_site_id,
        },
      };
      try {
        const response = await API.post('asulink', '/tickets/experience/remote/init', myInit);
        window.open(response.remote_session_uri);
      } catch (e) {
        console.log(e);
        remoteExpErr.value = e.response.data.message;
      }
    };

    return {
      remoteExpErr,
      enableTwoD,
      remoteInit,
    };
  },
});
</script>

<style scoped lang="scss">
p.text-danger:first-letter {
  text-transform: uppercase;
}
button {
  border: none !important;
  position: absolute;
  left: 745px;
  top: -20px;
}
.modal-dialog {
  padding-top: 60px;
  max-width: 732px;
  position: relative;
}
.modal-header {
  border-bottom: none;
}

.modal-content {
  background-color: #151515;
}
#infoa {
  max-width: 732px;
  background: #151515 0% 0% no-repeat padding-box;
}

.description {
  max-width: 443px;
  font-size: 14px;
}

.cyp-para {
  padding: 0px 200px;
  font-size: 14px;
}
</style>
